import React from 'react';

import PropTypes from 'prop-types';
import SignaturePad from 'react-signature-canvas';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {Box, Grid, IconButton, Typography, withStyles} from '@material-ui/core';

import {InferPropTypes} from 'commons/types/Types';
import {BiometricsStyles} from 'assets/tss/layouts/components';

function EfeSignaturePad(
    props: InferPropTypes<typeof EfeSignaturePad.propTypes, typeof BiometricsStyles>
) {
    const {classes, title, description, setSignature, signature, readonly} = props;
    const signCanvas = React.useRef() as React.MutableRefObject<SignaturePad>;
    const handleClear = () => {
        signCanvas.current.clear();
        setSignature('');
    };
    function updateSignature() {
        handleSave();
    }
    const handleSave = () => {
        setSignature(signCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
    };
    React.useEffect(() => {
        if (signature) {
            try {
                const blob = new Blob([signature]);
                const url = window.URL.createObjectURL(blob);
                setSignature(signCanvas.current.fromDataURL(url));
                if(readonly) {
                    signCanvas.current.off();
                }
            } catch (error) {
                console.error(error);
            }
        }
    }, []);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box m={2}>
                    <Typography className={classes.title} variant={'h6'}>
                        {title}
                    </Typography>
                    <Typography className={classes.description} variant={'subtitle2'}>
                        {description}
                    </Typography>
                    <Grid item className={classes.signPadActions}>
                        {!readonly && (
                            <IconButton onClick={handleClear}>
                                <DeleteForeverIcon />
                            </IconButton>
                        )}
                    </Grid>
                    <Box pb={2} className={classes.siganturePad}>
                        <Box m={2}>
                            <SignaturePad
                                penColor='black'
                                backgroundColor='white'
                                ref={signCanvas}
                                minWidth={1}
                                maxWidth={1}
                                minDistance={0}
                                canvasProps={{
                                    className: classes.signCanvas,
                                }}
                                // eslint-disable-next-line react/jsx-handler-names
                                onEnd={updateSignature}
                            />
                        </Box>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
}

EfeSignaturePad.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    setSignature: PropTypes.func.isRequired,
    signature: PropTypes.string.isRequired,
    readonly: PropTypes.bool.isRequired,
};

export default withStyles(BiometricsStyles)(EfeSignaturePad);
